module.exports = __webpack_public_path__ + "img/dl8.c1682ade.png";